interface Array<T> {
  sortBy(lambda: (item: T) => any): this;
  distinct(): any[];
  groupBy(lambda: (item: T) => any): { [prop: string]: T[] };
  toLabelValues(labelProp: string, valueProp: string): any[];
  first(): T;
  last(): T;
  get(index: number): T;
}

Array.prototype.sortBy = function (lambda: (item: any) => any) {
  return this.sort((a, b) => lambda(a) - lambda(b));
};

Array.prototype.distinct = function () {
  return this.filter((x, idx, array) => array.indexOf(x) === idx);
};

Array.prototype.groupBy = function (lambda: (item: any) => any): { [prop: string]: any[] } {
  return this.reduce((group, x) => {
    const val = lambda(x);
    group[val] = group[val] || [];
    group[val].push(x);
    return group;
  }, {});
};

Array.prototype.toLabelValues = function (labelProp: string, valueProp: string): any[] {
  return this.map(x => {
    if (x.hasOwnProperty(labelProp) === false) {
      throw new Error(`Property ${labelProp} does not exist.`);
    }
    if (x.hasOwnProperty(valueProp) === false) {
      throw new Error(`Property ${valueProp} does not exist.`);
    }
    const keyVal = x[labelProp];
    const valVal = x[valueProp];
    return { label: keyVal, value: valVal };
  });
}

Array.prototype.first = function (): any {
  return this.length === 0 ? undefined : this.get(0);
}

Array.prototype.last = function (): any {
  return this.length === 0 ? undefined : this.get(this.length - 1);
}

Array.prototype.get = function(index: number): any {
  try {
    return this[index];
  } catch {
    return undefined;
  }
}
